import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { SITE, NAV_AREE } from "../../data/site";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy-dark text-slate-300">
    <div className="container-site grid gap-10 py-14 sm:grid-cols-2 lg:grid-cols-4">
      <div>
        <p className="font-serif text-xl font-semibold text-white">{SITE.studio}</p>
        <p className="mt-3 text-sm leading-relaxed text-slate-400">
          Avvocato del lavoro e della previdenza a Palermo. Assistenza in licenziamenti,
          recupero crediti da lavoro e TFR, pensioni, invalidità civile e ricorsi INPS.
        </p>
        <p className="mt-4 text-xs text-slate-500">
          Iscritto all'Ordine degli Avvocati di Palermo
        </p>
      </div>
      <nav aria-label="Aree di attività">
        <p className="text-sm font-semibold uppercase tracking-[0.18em] text-gold">Aree di attività</p>
        <ul className="mt-4 space-y-2.5 text-sm">
          {NAV_AREE.map((l) => (
            <li key={l.path}>
              <Link
                to={l.path}
                data-testid={`footer-link-${l.path.slice(1)}`}
                className="transition-colors hover:text-gold-light"
              >
                {l.name}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <nav aria-label="Studio">
        <p className="text-sm font-semibold uppercase tracking-[0.18em] text-gold">Studio</p>
        <ul className="mt-4 space-y-2.5 text-sm">
          <li><Link to="/chi-sono" data-testid="footer-link-chi-sono" className="transition-colors hover:text-gold-light">Chi sono</Link></li>
          <li><Link to="/recensioni" data-testid="footer-link-recensioni" className="transition-colors hover:text-gold-light">Recensioni</Link></li>
          <li><Link to="/approfondimenti" data-testid="footer-link-approfondimenti" className="transition-colors hover:text-gold-light">Approfondimenti</Link></li>
          <li><Link to="/contatti" data-testid="footer-link-contatti" className="transition-colors hover:text-gold-light">Contatti</Link></li>
          <li>
            <a href={SITE.googleProfile} target="_blank" rel="noopener noreferrer" data-testid="footer-link-google-profile" className="transition-colors hover:text-gold-light">
              Profilo Google dello studio
            </a>
          </li>
        </ul>
      </nav>
      <div>
        <p className="text-sm font-semibold uppercase tracking-[0.18em] text-gold">Contatti</p>
        <ul className="mt-4 space-y-3 text-sm">
          <li className="flex items-start gap-2.5">
            <MapPin size={16} className="mt-0.5 shrink-0 text-gold" aria-hidden="true" />
            <span>{SITE.address}</span>
          </li>
          <li>
            <a href={SITE.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-2.5 transition-colors hover:text-gold-light">
              <Phone size={16} className="shrink-0 text-gold" aria-hidden="true" /> {SITE.phone}
            </a>
          </li>
          <li>
            <a href={SITE.emailHref} data-testid="footer-email-link" className="flex items-center gap-2.5 break-all transition-colors hover:text-gold-light">
              <Mail size={16} className="shrink-0 text-gold" aria-hidden="true" /> {SITE.email}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="container-site flex flex-col items-start justify-between gap-3 py-6 text-xs text-slate-500 sm:flex-row sm:items-center">
        <p>© {new Date().getFullYear()} {SITE.studio} — Tutti i diritti riservati.</p>
        <p className="flex gap-5">
          <Link to="/privacy-policy" data-testid="footer-link-privacy" className="transition-colors hover:text-gold-light">Privacy Policy</Link>
          <Link to="/cookie-policy" data-testid="footer-link-cookie" className="transition-colors hover:text-gold-light">Cookie Policy</Link>
          <button
            type="button"
            onClick={() => window.dispatchEvent(new Event("open-cookie-preferences"))}
            data-testid="footer-cookie-preferences"
            className="transition-colors hover:text-gold-light"
          >
            Gestisci cookie
          </button>
          <Link to="/admin" data-testid="footer-link-admin" className="text-slate-600 transition-colors hover:text-gold-light">Area riservata</Link>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
